<template>
  <div class="customers-register" />
</template>

<script>

/**
 * Vue: Customers register (customers-register)
 * -----------------------------------------------------------------------------
 * Register page section.
 * - Limited interactivity component.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'CustomersRegister',

  data() {
    return {
      nodeSelectors: false,
    }
  },

  mounted() {
    this.setNodeSelectors()

    if (!this.nodeSelectors.registerForm) {
      return
    }

    this.setEventListeners()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setNotification: 'setNotification',
    }),

    /**
     * Set node selectors.
      */
    setNodeSelectors() {
      this.nodeSelectors = {
        registerForm: document.querySelector('[js-register="form"]'),
      }
    },

    /**
     * Set event listeners.
     */
    setEventListeners() {
      if (!this.$variable('settings.notifications.register')) {
        return
      }

      this.nodeSelectors.registerForm.addEventListener('submit', async(event) => {
        event.preventDefault()

        this.setNotification({
          displayUrl: this.$variable('routes.root'),
          text: this.$string('customers.notifications.register'),
          timeout: this.$timing('message'),
          type: 'success',
        })
        this.ometriaSubmit(event)

        await cnvs.Sleep(0)
        this.nodeSelectors.registerForm.submit()
      })
    },

    /**
     * Submit data to ometria.
     * @param {Object} event - Submit event.
     */
    ometriaSubmit(event) {
      if (!window.ometria) {
        return
      }

      const subscriptionStatus = event.target.querySelector('#accepts-marketing').checked
        ? 'SUBSCRIBED'
        : 'UNCHANGED'
      const data = {
        __email: '',
        '@account': cnvs.credentials.ometria.accountId,
        '@subscription_status': subscriptionStatus,
        firstname: event.target.querySelector('#first-name').value,
        lastname: event.target.querySelector('#last-name').value,
        ue: event.target.querySelector('#email').value,
      }
      const urlEncodedDataPairs = Object.keys(data).map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      })

      let formBody = []

      formBody = urlEncodedDataPairs.join('&').replace(/%20/g, '+')

      fetch('https://api.ometria.com/forms/signup/ajax', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      })
    },
  },
}
</script>

<style lang="scss">
@import '~async/utils/checkbox-input/checkbox-input';
@import './customers-register';
</style>
